import {Outlet, useLocation, useNavigate} from "react-router-dom"
import {useEffect} from "react"

type RedirectRouterProps = {
    from: string,
    to: string,
}

export function RedirectRouter({from, to}: RedirectRouterProps) {
    const {pathname} = useLocation()
    const navigate = useNavigate()
    console.log("pathname: ", pathname)
    useEffect(() => {
        if (!pathname || pathname === from) {
            navigate(to)
        }
    }, [from, navigate, pathname, to])
    return (
        <Outlet/>
    )
}